import React from 'react';

const PrivacyMag = () => {
  return <div>PrivacyMag</div>;
};

export default PrivacyMag;
